import { useSelector } from 'react-redux';
import { omit, compose } from 'lodash/fp';
import { RootState } from '../../../../global';
import { buyOrderPeopleSelectors } from '../people/people-redux';
import { buyOrderOrganizationsSelectors } from './organizations-redux';

export const useBuyOrderOrganizations = (id: string) =>
  useSelector((state: RootState) =>
    buyOrderOrganizationsSelectors.selectAll(state.buyOrderOrganizations[id]));

export const useLegalShareholders = (id: string) => {
  const organizations = useBuyOrderOrganizations(id);
  const { legalShareholders } = useSelector(
    (state: RootState) => state.buyOrderEdit[id].ownerShares,
  );

  const people = useSelector((state: RootState) =>
    buyOrderPeopleSelectors.selectEntities(state.buyOrderPeople[id]));

  const omitPersonProperties = omit([
    'city',
    'address',
    'postalCode',
    'person',
    'relationId',
  ]);

  const omitOrganizationProperties = omit('organization');

  return legalShareholders.map((legal) => {
    const organization = organizations.find(
      (organization) => legal?.organization === organization?.organizationNumber,
    );
    const person = people[organization?.person ?? ''];

    return compose(
      omitPersonProperties,
      omitOrganizationProperties,
    )({
      ...person,
      ...organization,
      ...legal,
    });
  });
};
